import { cx } from '@/utils/cx';

type Props = {
  initials: string;
  size?: number;
  bg?: string;
  color?: string;
  className?: string;
};

export const Avatar = ({ initials, size = 32, bg, color, className }: Props) => (
  <span
    className={cx('avatar', className)}
    style={{
      width: size,
      height: size,
      fontSize: Math.round(size * 0.36),
      background: bg,
      color,
    }}
  >
    {initials}
  </span>
);
